module.exports = __webpack_public_path__ + "img/camera.db476b18.png";